export const SCROLL_CONTAINER_CLASS = 'calendar-scroll-container';
